import styled from 'styled-components/macro'

export default styled.h1`
  margin: 0;
  text-transform: uppercase;
  font-size: ${props => props.theme.medium};
  font-weight: ${props => props.theme.bold};
`
